import React,{useState} from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import SafeIcon from '../../common/SafeIcon';

const Layout=({children,activeTab,setActiveTab})=> {
  const [mobileMenuOpen,setMobileMenuOpen]=useState(false);
  
  return (
    <div className="flex h-screen bg-sp-black overflow-hidden bg-grid-pattern selection:bg-sp-lime selection:text-sp-black">
      {/* Mobile Drawer Overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/90 z-40 md:hidden backdrop-blur-md transition-opacity duration-300" 
          onClick={()=> setMobileMenuOpen(false)} 
        />
      )}

      {/* Mobile Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 w-72 transform transition-transform duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] md:hidden ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <Sidebar activeTab={activeTab} setActiveTab={(tab)=> {setActiveTab(tab);setMobileMenuOpen(false);}} />
      </div>

      {/* Desktop Sidebar */}
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative">
        {/* Ambient background glow effect */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-sp-lime/[0.03] rounded-full blur-[120px] pointer-events-none -z-10"></div>
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-sp-cyan/[0.03] rounded-full blur-[100px] pointer-events-none -z-10"></div>
        
        <Header setMobileMenuOpen={setMobileMenuOpen} />
        
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-10 relative z-0">
          <div className="max-w-7xl mx-auto w-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;